import palette from "../palette";

const MuiLink = {
  styleOverrides: {
    root: {
      cursor: "pointer",
      color: palette.link.main,
      fontSize: "0.9rem", // ~14.4px, closer to 14px p1 text
      fontWeight: "semiBold",
      "&:hover": {
        color: palette.link.dark,
      },

      "@media (min-width: 768px)": {
        fontSize: "1.0rem", // 16px to match md+ paragraph sizes
      },
      "@media (min-width: 1024px)": {
        fontSize: "1.125rem", // 18px to match lg+ paragraph sizes
      },
      "@media (min-width: 1440px)": {
        fontSize: "1.25rem", // 20px to match xl+ paragraph sizes
      },
    },
  },
};

export default MuiLink;
